namespace TabAurous.Sales {
    export namespace DeliveryChallanItemsService {
        export const baseUrl = 'Sales/DeliveryChallanItems';

        export declare function Create(request: Serenity.SaveRequest<DeliveryChallanItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<DeliveryChallanItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DeliveryChallanItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<DeliveryChallanItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<DeliveryChallanItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function DeliveryChallanReturnCheck(request: TransactionRequest, onSuccess?: (response: Serenity.RetrieveResponse<DeliveryChallanItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sales/DeliveryChallanItems/Create",
            Update = "Sales/DeliveryChallanItems/Update",
            Delete = "Sales/DeliveryChallanItems/Delete",
            Retrieve = "Sales/DeliveryChallanItems/Retrieve",
            List = "Sales/DeliveryChallanItems/List",
            CustomList = "Sales/DeliveryChallanItems/CustomList",
            DeliveryChallanReturnCheck = "Sales/DeliveryChallanItems/DeliveryChallanReturnCheck"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'DeliveryChallanReturnCheck'
        ].forEach(x => {
            (<any>DeliveryChallanItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
